import { computed } from 'mobx';
import TncRepository from '../../repositories/TncRepository';
import OrderDataViewController,
{ IOrderDataConfig } from '../OrderDataViewController/OrderDataViewController';
import { FIELD_TYPE } from '../../constants/Constants';

export interface ITncViewControllerConfig extends IOrderDataConfig {
  tncRepository: TncRepository;
}

interface ITncViewControllerData {
  tncHtmlContent: string;
}

export default class TncViewController extends OrderDataViewController {
  private tncRepository: TncRepository;

  constructor(config: ITncViewControllerConfig) {
    super(config);
    this.tncRepository = config.tncRepository;
  }

  async loaded(): Promise<void> {
    await Promise.all([
      super.loaded(),
      this.tncRepository.loadTncHtmlContent(),
    ]);
  }

  @computed
  get data(): ITncViewControllerData {
    return {
      tncHtmlContent: this.tncFormattedContent,
    };
  }

  @computed
  get tncFormattedContent(): string {
    const { tncHtmlContent } = this.tncRepository;

    const billToCompany = this.companyBillingDetails ? `${Number(this.companyBillingDetails.attributes[FIELD_TYPE.BILL_TO_COMPANY])}` : '0';
    const companyName = this.companyBillingDetails ? this.companyBillingDetails.attributes[FIELD_TYPE.COMPANY_NAME] : '';
    const companyTaxNumber = this.companyBillingDetails ? this.companyBillingDetails.attributes[FIELD_TYPE.COMPANY_TAX_NUMBER] : '';
    const companyAddress = this.companyBillingDetails ? this.companyBillingDetails.attributes[FIELD_TYPE.COMPANY_ADDRESS] : '';
        

    return (tncHtmlContent || '')
      .replace(/::full_name::/gi, this.shippingFullName)
      .replace(/::shipping_addr::/gi, this.shippingLineAddress)
      .replace(/::billing_addr::/gi, this.billingLineAddress)
      .replace(/::selling_price::/gi, this.sellPrice)
      .replace(/::shipping_cost::/gi, this.shippingCost)
      .replace(/::total_cost::/gi, this.totalCost)
      .replace(/::reg_address::/gi, this.billingLineAddress)
      .replace(/::phone::/gi, this.shippingPhone)
      .replace(/::email::/gi, this.userEmail)
      .replace(/::product_rows::/gi, this.orderItems)
      .replace(/::payment_type::/gi, this.paymentTypeLabel)
      .replace(/::bill_to_company::/gi, billToCompany)
      .replace(/::bill_to_company.company_name::/gi, `${companyName}`)
      .replace(/::bill_to_company.company_tax_number::/gi, `${companyTaxNumber}`)
      .replace(/::bill_to_company.company_address::/gi, `${companyAddress}`);
  }

  @computed
  get orderItems(): string {
    return this.cartItems.map(item => ` 
      <tr>
        <td>${item.productCode}</td>
        <td>${item.productRgnName}</td>
        <td>${item.quantity}</td>
        <td>${item.formattedAppliedPrice}</td>
        <td>${item.formattedAppliedPrice}</td>
        <td>${item.formattedAppliedPrice}</td>
      </tr>
    `).join();
  }
}
